import { DoorType } from 'graphql/generated/graphqlTypes';
import { Colors } from 'theme/theme';
import { Props as IconProps, Icons } from 'ui/atoms/Icon/Icon';

export interface LockIconProperties {
  name: Icons;
  color?: keyof Colors;
  stroke?: keyof Colors;
}

export const getLockIconProperties = (
  doorType: DoorType | null,
  color: keyof Colors = 'lTextHigh'
): Pick<IconProps, 'name' | 'color' | 'stroke'> => {
  switch (doorType) {
    case DoorType.DomCylinder:
      return {
        name: 'Cylinder',
        color
      };
    case DoorType.DomHandle:
      return {
        name: 'Handle',
        color
      };
    case DoorType.DomReader:
      return {
        name: 'Reader',
        color
      };
    case DoorType.DomLocker:
      return {
        name: 'Locker',
        color
      };
    case DoorType.DomController:
      return {
        name: 'UniversalReaderIntercom',
        color
      };
    case DoorType.Tanlock:
      return {
        name: 'SwingHandleTANLock',
        color
      };
    default:
      return {
        name: '' as Icons
      };
  }
};

export const getLockTooltipText = (doorType: DoorType | null): String | undefined => {
  // eslint-disable-next-line no-magic-numbers
  switch (doorType) {
    case DoorType.DomCylinder:
      return 'Cylinder';
    case DoorType.DomHandle:
      return 'Handle';
    case DoorType.DomReader:
      return 'Reader';
    case DoorType.DomLocker:
      return 'Locker';
    case DoorType.DomController:
      return 'Controller';
    case DoorType.Tanlock:
      return 'Tanlock';
    default:
      return undefined;
  }
};

export default { getLockIconProperties, getLockTooltipText };
